import type { Step } from "react-joyride";

export const leaveRequestDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າລາຍລະອຽດຄຳຂໍລາ. ເບິ່ງຂໍ້ມູນຄຳຂໍລາ ກັບຄືນ ຫຼື ແກ້ໄຂ (ຖ້າລໍຖ້າອະນຸມັດ). ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-request-detail-back"]',
    content: "ກັບຄືນສູ່ລາຍການ. ກົດປຸ່ມວົງມົນເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-request-detail-form"]',
    content: "ລາຍລະອຽດຄຳຂໍລາ. ສາມາດແກ້ໄຂໄດ້ຖ້າສະຖານະຍັງລໍຖ້າອະນຸມັດ.",
    placement: "top",
  },
];
